import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripUrlPrefix',
  standalone: true,
})
export class StripUrlPrefixPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    return value.trim().replace(/^(https?:\/\/)?(www\.)?/i, '');
  }
}
